import styled from 'styled-components'

export const H3 = styled.h3`
  font-size: 24px;
  color: ${({ theme }) => theme.palette.gray[800]};
`
